import React from 'react';
import ReactModal from 'react-modal';
import ModalTitle from './modalTitle';


const Modal = (props) => {
    let style = props.style ? props.style :  {
        overlay :{},
        content : {
            top :"80px",
            left : "100px",
            right : "100px",
            "z-Index" : "1000"
        }
    };
    let title =  props.title ? props.title : "";
    return (
             <ReactModal contentLabel="" isOpen={props.isOpen} onRequestClose={props.onRequestClose} style={style}>
                <ModalTitle title={title} />
                {props.children}
            </ReactModal>
        );
};

export default Modal;


// WEBPACK FOOTER //
// ./src/components/common/modal.js